/** Import modules */

import {

    useLocation,

    useNavigate

}                           from "react-router-dom";

/** Import hooks */

import { TyresNavigator }    from "../../../Hooks/TyresNavigator";

import { scrollElement }     from "../../../Misc/ScrollElement";

/** Import icons */

import {

    HiChevronLeft,

    HiChevronRight

}                           from "react-icons/hi";

/**
 *
 * @param { pageInfo, totalCount } param0
 *
 * @returns Winter tyre pagination component
 *
 */

const WinterPagination = ( { pageInfo, totalCount, basePath = "/ziemas-riepas" } ) => {

    const

    navigate = useNavigate (),

    { search } = useLocation (),

    pageSize = 21,

    totalPages = Math.ceil ( totalCount / pageSize ),

    searchParams = new URLSearchParams ( search ),

    currentPage = Math.max ( 1, parseInt ( searchParams.get ( "p" ) ) || 1 ),

    navigateTo = query => {

        const nextParams = new URLSearchParams ( TyresNavigator ( searchParams, {

            ...query,

            p: query.p || currentPage

        } ) );

        navigate ( {

            pathname: basePath,

            search: nextParams.toString () ? `?${ nextParams.toString () }` : ""

        } );

        window.requestAnimationFrame ( () => window.requestAnimationFrame ( () => {

            if ( document.querySelector ( ".winter-tyres-page__products" ) ) scrollElement ( ".winter-tyres-page__products" );

        } ) );

    },

    firstPage = {

        f: pageSize,

        l: null,

        a: null,

        b: null,

        lp: null,

        p: 1

    },

    previousPage = {

        f: null,

        l: pageSize,

        a: null,

        b: pageInfo.startCursor,

        lp: null,

        p: Math.max ( 1, currentPage - 1 )

    },

    nextPage = {

        f: pageSize,

        l: null,

        a: pageInfo.endCursor,

        b: null,

        lp: null,

        p: currentPage + 1

    },

    previousNumber = {

        f: null,

        l: pageSize,

        a: null,

        b: pageInfo.startCursor,

        lp: null,

        p: currentPage - 1

    },

    nextNumber = {

        f: pageSize,

        l: null,

        a: pageInfo.endCursor,

        b: null,

        lp: null,

        p: currentPage + 1

    },

    lastPage = {

        f: null,

        l: totalCount % pageSize || pageSize,

        a: null,

        b: null,

        lp: true,

        p: totalPages

    };

    if ( totalPages <= 1 ) return null;

    /** Return component */

    return ( <div className="pagination" aria-label="Ziemas riepu lapas">

        { currentPage > 1 && <button

            className="navigation-button"

            onClick={ () => navigateTo ( previousPage ) }

            disabled={ ! pageInfo.hasPreviousPage }>

            <HiChevronLeft />

        </button> }

        { currentPage === 1 ? <button className="current-page" aria-current="page" disabled>1</button> : <button

            className="page-number"

            onClick={ () => navigateTo ( firstPage ) }>

            1

        </button> }

        { currentPage > 3 && <span className="pagination-ellipsis">...</span> }

        { currentPage > 2 && <button

            className="page-number"

            onClick={ () => navigateTo ( previousNumber ) }>

            { currentPage - 1 }

        </button> }

        { currentPage > 1 && <button className="current-page" aria-current="page" disabled>{ currentPage }</button> }

        { currentPage < totalPages && <button

            className="page-number"

            onClick={ () => navigateTo ( nextNumber ) }>

            { currentPage + 1 }

        </button> }

        { currentPage < totalPages - 2 && <span className="pagination-ellipsis">...</span> }

        { totalPages > currentPage + 1 && <button

            className="page-number"

            onClick={ () => navigateTo ( lastPage ) }>

            { totalPages }

        </button> }

        { currentPage < totalPages && <button

            className="navigation-button"

            onClick={ () => navigateTo ( nextPage ) }

            disabled={ ! pageInfo.hasNextPage }>

            <HiChevronRight />

        </button> }

    </div> );

}

/** Export component */

export default WinterPagination;